import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from "vue-router-prefetch";
import VueSimpleAlert from "vue-simple-alert";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";

import BlackDashboard from "@/plugins/blackDashboard";
import ConsoleLogger from "@/plugins/consoleLogger";
import SimpleLayout from "@/layout/simpleLayout/SimpleLayout.vue";
import WelcomeLayout from "@/layout/simpleLayout/WelcomeLayout.vue";

import { router } from "@/router/index";
// import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import App from "@/App";

Vue.use(VueSimpleAlert);
Vue.use(BlackDashboard);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(ElementUI, { locale });

Vue.use(ConsoleLogger);

Vue.component("simple-layout", SimpleLayout);
Vue.component("welcome-layout", WelcomeLayout)
/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
